module.exports = __webpack_public_path__ + "assets/img/BodyLux-w960.4de1cc5c.webp";